import Layout from "../components/Layouts";
import Nav from "../components/Navi";
import Footer from "../components/Footers";
import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import WeatherWidget from "@components/weather/WeatherWidget";
import styles from "../styles/faqs.module.scss";
export default function FAQs() {
  const { t } = useTranslation("common");
  const [scrollY, setScrollY] = React.useState(false);
  React.useEffect(() => {
    import("lottie-interactive/dist/lottie-interactive.js");
    const handleScroll = () => {
      setScrollY(window.scrollY);
      if (window.screen.width < 1199) setScrollY(320);
    };

    // just trigger this so that the initial state
    // is updated as soon as the component is mounted
    // related: https://stackoverflow.com/a/63408216
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
  return (
    <>
      <div
        className={`${styles.faqs} container pt-5 mt-5 faqs position-relative`}
      >
        <div className="d-flex justify-content-between">
          <div className="page-title fw-bold has-diamonds">
            Frequently Asked Questions{" "}
          </div>
          {/* <div className={`${styles.lottieWrapper}`}>
            <lottie-interactive
              path="/assets/lottie/explore-qatar-1.json"
              interaction="play-on-show"
            />
          </div> */}
        </div>
        <div id="shortcuts"></div>
        {/* <div className={`${styles.shortcutContainer} text-burgundy`} id="shortcuts">
          <h5 className="  fw-bold mb-4">Shortcuts:</h5>
          <div><a href="#faqGeneral" className="  ">{t("faqs_headerAccreditation")}</a></div>
          <div><a href="#faqRegistration" className="  ">FAQ - Registration</a></div>
          <div><a href="#faqHayya" className="  ">FAQ - Hayya</a></div>
          <div><a href="#faqAccomodation" className="">FAQ - Accomodation</a></div>
          <div><a href="#faqFimlingPermits" className=" ">FAQ - Film permits</a></div>
          <div><a href="#faqEquipmentClearance" className="">FAQ - Equipment clearance</a></div>
          <div><a href="#faqCovid" className="  ">FAQ - COVID Regulations</a></div>
          <div><a href="#faqQMPHCMS" className=" ">FAQ - QMP Host Country Media Services</a></div>

        </div> */}
        <div id="faqGeneral">
          <h1
            className={`${styles.sectionstitle} text-burgundy fw-bold `}
          >
           {t("faqs_headerAccreditation")}
          </h1>
          <div className="ps-md-5 mt-5">
            <div>
              {/* <h1 className="fw-bold text-burgundy">1</h1> */}
              <div className={`${styles.question}   fw-bold`}>
               {t("accreditation_q_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_1")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("accreditation_q_2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_2_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_2_2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_2_3")}
              </div>
             < div className={`${styles.question}   fw-bold`}>
               {t("accreditation_q_3")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_3")}
              </div>
              < div className={`${styles.question}   fw-bold`}>
               {t("accreditation_q_4")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_4_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_4_2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_4_3")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_4_4")}
              </div>
              < div className={`${styles.question}   fw-bold`}>
               {t("accreditation_q_5")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_5")}
              </div>
              < div className={`${styles.question}   fw-bold`}>
               {t("accreditation_q_6")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_6")}
              </div>
              < div className={`${styles.question}   fw-bold`}>
               {t("accreditation_q_7")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_7")}
              </div>
              < div className={`${styles.question}   fw-bold`}>
               {t("accreditation_q_8")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_8")}
              </div>
              < div className={`${styles.question}   fw-bold`}>
               {t("accreditation_q_9")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_9")}
              </div>
              < div className={`${styles.question}   fw-bold`}>
               {t("accreditation_q_10")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_10")}
              </div>
              < div className={`${styles.question}   fw-bold`}>
               {t("accreditation_q_11")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_11_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accreditation_a_11_2")}
              </div>
            </div>
           
          </div>
          <h1
            className={`${styles.sectionstitle} text-burgundy fw-bold `}
          >
           {t("faqs_headerEntryPermit")}
          </h1>
          <div className="ps-md-5 mt-5">
          < div className={`${styles.question}   fw-bold`}>
               {t("entryPermit_q_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("entryPermit_a_1_1")}
              </div>
              <div className={`${styles.answer} fw-bold mt-2 text-decoration-underline`} style={{fontSize:"14px"}}>
              {t("entryPermit_a_1_2_note")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("entryPermit_a_1_3")}
              </div>
              < div className={`${styles.question}   fw-bold`}>
               {t("entryPermit_q_2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("entryPermit_a_2")}
              </div>
              < div className={`${styles.question}   fw-bold`}>
               {t("entryPermit_q_3")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("entryPermit_a_3")}
              </div>              < div className={`${styles.question}   fw-bold`}>
               {t("entryPermit_q_4")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("entryPermit_a_4")}
              </div>
            < div className={`${styles.question}   fw-bold`}>
               {t("entryPermit_q_5")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("entryPermit_a_5")}
              </div>
          </div>
          <h1
            className={`${styles.sectionstitle} text-burgundy fw-bold `}
          >
           {t("faqs_headerFilmPermit")}
          </h1>
          <div className="ps-md-5 mt-5">
              <div className={`${styles.question}   fw-bold`}>
               {t("filmPermit_q_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_1")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("filmPermit_q_2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_2")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("filmPermit_q_3")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_3_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_3_2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_3_3")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_3_4")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("filmPermit_q_4")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_4")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("filmPermit_q_5")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_5")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("filmPermit_q_6")}
              </div>
              <div className={`${styles.answer}   mt-2  fw-bold`}>
              {t("filmPermit_a_6_1H")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_6_1")}
              </div>
              <div className={`${styles.answer}   mt-2  fw-bold`}>
              {t("filmPermit_a_6_2H")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_6_2")}
              </div>
              <div className={`${styles.answer}   mt-2  fw-bold`}>
              {t("filmPermit_a_6_3H")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_6_3")}
              </div>
              <div className={`${styles.answer}   mt-2  fw-bold`}>
              {t("filmPermit_a_6_4H")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_6_4")}
              </div>
              <div className={`${styles.answer}   mt-2  fw-bold`}>
              {t("filmPermit_a_6_5H")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_6_5")}
              </div>
              <div className={`${styles.answer}   mt-2  fw-bold`}>
              {t("filmPermit_a_6_6H")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_6_6")}
              </div>
              <div className={`${styles.answer}   mt-2  fw-bold`}>
              {t("filmPermit_a_6_7H")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_6_7")}
              </div>
              <div className={`${styles.answer}   mt-2  fw-bold`}>
              {t("filmPermit_a_6_8H")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_6_8")}
              </div>
              <div className={`${styles.answer}   mt-2  fw-bold`}>
              {t("filmPermit_a_6_9H")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_6_9")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("filmPermit_q_7")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_7_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_7_2")}
              </div>
              {/* <div className={`${styles.question}   fw-bold`}>
               {t("filmPermit_q_8")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_8_1")}
              </div> */}
              <div className={`${styles.question}   fw-bold`}>
               {t("filmPermit_q_9")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_1_p1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_1_p2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_1_p3")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_1_p4")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_1_p5")}
              </div>

              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_2_p1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_2_p2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_2_p3")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_2_p4")}
              </div>
            
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_3")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_3_p1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_3_p2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_3_p3")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("filmPermit_a_9_3_p4")}
              </div>
          </div>

          <h1
            className={`${styles.sectionstitle} text-burgundy fw-bold `}
          >
           {t("faqs_headerEquipment")}
          </h1>
          <div className="ps-md-5 mt-5">
            <div className={`${styles.question}   fw-bold`}>
               {t("equipment_q_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("equipment_a_1_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("equipment_a_1_2")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("equipment_q_3")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("equipment_a_3")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("equipment_q_4")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("equipment_a_4_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("equipment_a_4_2")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("equipment_q_5")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("equipment_a_5")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("equipment_q_6")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("equipment_a_6")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("equipment_q_7")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("equipment_a_7_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("equipment_a_7_2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("equipment_a_7_3")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("equipment_a_7_4")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("equipment_a_7_5")}
              </div>
          </div>

          <h1
            className={`${styles.sectionstitle} text-burgundy fw-bold `}
          >
           {t("faqs_headerDrones")}
          </h1>
          <div className="ps-md-5 mt-5">

            <div className={`${styles.question}   fw-bold`}>
               {t("drones_q")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("drones_a")}
              </div>
          </div>
          <h1
            className={`${styles.sectionstitle} text-burgundy fw-bold `}
          >
           {t("faqs_headerAccommodation")}
          </h1>
          <div className="ps-md-5 mt-5">
             <div className={`${styles.question}   fw-bold`}>
               {t("accommodation_q")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("accommodation_a")}
              </div>
          </div>
          <h1
            className={`${styles.sectionstitle} text-burgundy fw-bold `}
          >
           {t("faqs_headerArrival")}
          </h1>
          <div className="ps-md-5 mt-5">
            <div className={`${styles.question}   fw-bold`}>
               {t("arrival_q_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("arrival_a_1")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("arrival_q_2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("arrival_a_2")}
              </div>
              <div className={`${styles.question}   fw-bold`}>
               {t("arrival_q_3")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("arrival_a_3")}
              </div>
          </div>
          <h1
            className={`${styles.sectionstitle} text-burgundy fw-bold `}
          >
           {t("faqs_headerOther")}
          </h1>
          <div className="ps-md-5 mt-5">
            <div className={`${styles.question}   fw-bold`}>
               {t("other_q")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("other_a_1")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("other_a_2")}
              </div>
              <div className={`${styles.answer}   mt-2`}>
              {t("other_a_3")}
              </div>
            
          </div>
        </div>
        {/* <div id="faqGeneral">
          <h1
            className={`${styles.sectionstitle}   fw-bold `}
          >
            FAQ - General
          </h1>
          <div className="ps-md-5 mt-5">
            <div>
              <h1 className="fw-bold text-burgundy">1</h1>
              <div className={`${styles.question}   fw-bold`}>
                What is the Hayya Media Portal?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                The Hayya Media Portal is a web-based resource for media
                attending the FIFA World Cup Qatar 2022™. It is the main
                platform that enables media to apply for necessary permits to
                enter & film in Qatar during the tournament. The Hayya Media
                Portal offers services to three categories of Media:
              </div>
              <div className="mt-4">
                <img
                  src="/assets/images/media-portal.jpg"
                  alt="media-portal"
                  className="w-100"
                />
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">2</h1>
              <div className={`${styles.question}   fw-bold`}>
                Do I need to apply on the Hayya Media Portal to travel to Qatar?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                Yes, it is <span>mandatory</span> for media traveling to Qatar
                for the FIFA World Cup Qatar 2022 to register on the Hayya Media
                Portal. The application process has been streamlined to provide
                applicants a single application to generate the following:{" "}
              </div>
              <ul>
                <li className={`${styles.answer}   mt-3`}>
                  -Hayya Entry Permit, as all visa processes will be suspended
                  from 1 November{" "}
                </li>
                <li className={`${styles.answer}   `}>
                  -Nationwide Filming & Photography Permit valid from 1 November
                  to 31 December 2022{" "}
                </li>
                <li className={`${styles.answer}   `}>
                  -Hand Carry Equipment Clearance
                </li>
              </ul>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">3</h1>
              <div className={`${styles.question}   fw-bold`}>
                How can I apply for Accreditation?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                Media can apply for Accreditation through the Hayya Media
                Portal. Please visit the Hayya Media Portal at{" "}
                <a
                  href="https://media.hayya.qa"
                  className="text-red"
                  target="_blank"
                >
                  https://media.hayya.qa
                </a>
                . From the top right-hand corner, please Click ‘Sign In’. If you
                have an existing account, simply sign-in, or click on ‘Register
                Here’ (bottom of the window) to create a new account.
              </div>
              <div className={`${styles.answer}   mt-3`}>
                All information provided on the application must be accurate,
                and provide valid documentation in line with standard visa
                requirements worldwide. Incorrect or inaccurate information may
                result in delays with obtaining the required approvals.{" "}
              </div>
              <ul>
                <li className={`${styles.answer}   mt-3`}>
                  -All personal information must be identical to the information
                  included in the applicant’s Passport or Qatar Identification
                  Document (QID){" "}
                </li>
                <li className={`${styles.answer}  `}>
                  -It is advisable that all documents are readily available:
                  Passport, personal photo and credentials
                </li>
              </ul>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">4</h1>
              <div className={`${styles.question}   fw-bold`}>
                What is the difference between FIFA-Accredited & Host Country
                Accredited Media?
              </div>
              <ul>
                <li className={`${styles.answer}   mt-2`}>
                  -
                  <span className="text-burgundy fw-medium text-decoration-none">
                    FIFA Media & Broadcast Accreditation
                  </span>{" "}
                  is provided by FIFA. This accreditation gives applicants
                  access to: FIFA World Cup Qatar 2022™ Stadiums, Official Team
                  Training Sites & the Main Media Centre (MMC) and International
                  Broadcast Centre (IBC) at Qatar National Convention Centre
                  (QNCC). FIFA-Accredited Media receive a Host Country Media
                  Upgrade Pass by applying through the Hayya Media Portal in
                  addition to the Hayya Entry Permit. The pass enables access to
                  the FIFA Fan Festival, Host Country Media Centre (HCMC) and
                  allows the holder to film in touristic sites around the
                  country without requesting for additional permits.{" "}
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  -
                  <span className="text-burgundy fw-medium text-decoration-none">
                    Host Country Media & Broadcast Accreditation
                  </span>{" "}
                  is offered by the Host Country and offers applicants who do
                  not hold FIFA Accreditation access to the FIFA Fan Festival,
                  Host Country Media Centre (HCMC), and allows the holder to
                  film in touristic sites around the country without requesting
                  for additional permits.
                </li>
              </ul>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">5</h1>
              <div className={`${styles.question}   fw-bold`}>
                How long is my Accreditation valid for?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                Host Country Media Accreditation & Host Country Media Upgrade
                Pass are valid from the date of physical collection of the card
                (from the Host Country Accreditation Centre at Msheireb
                Downtown), starting 01 November 2022 and are valid until 31
                December 2022.
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">6</h1>
              <div className={`${styles.question}   fw-bold`}>
                From where can I collect my accreditation?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                <span className="fw-medium text-decoration-none text-dark-grey">
                  FIFA-Accredited media
                </span>{" "}
                can collect their Host Country Upgrade Passes from{" "}
                <a
                  href="https://goo.gl/maps/sRJShoB3DcqKQTGZ9"
                  target="_blank"
                  className="text-red"
                >
                  the Qatar National Convention Centre
                </a>{" "}
                (QNCC) or the FIFA Fan Festival (FFF) after they receive an
                email informing them that their accreditation is ready for
                collection.{" "}
              </div>
              <div className={`${styles.answer}   mt-3`}>
                <span className="fw-medium text-decoration-none text-dark-grey">
                  Host Country Accredited media
                </span>{" "}
                can collect their accreditation from the{" "}
                <a
                  href="https://maps.google.com/?q=25.284828,51.528458"
                  target="_blank"
                  className="text-red"
                >
                  Host Country Media Centre
                </a>{" "}
                (HCMC), located in Msheireb, after they receive an email
                informing them that their accreditation is ready for collection.
              </div>
            </div>
          </div>
        </div>
        <div id="faqRegistration">
          <h1
            className={`${styles.sectionstitle} text-burgundy   fw-bold `}
          >
            FAQ - Registration
          </h1>
          <div className="ps-md-5 mt-5">
            <div>
              <h1 className="fw-bold text-burgundy">1</h1>
              <div className={`${styles.question}   fw-bold`}>
                I’m trying to register, but it says my email already exists.
                What do I do?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                If you receive this message, please Sign In using the username &
                password that was used previously to create an account. If you
                face any other issues in this regard, please send an email to{" "}
                <a className="text-red" href="mailto:media@hayya.qa">
                  {t("support-email")}
                </a>
                .
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">2</h1>
              <div className={`${styles.question}   fw-bold`}>
                I receive an Error message when I try to submit, what do I do?
              </div>
              <ul>
                <li className={`${styles.answer}   mt-2`}>
                  -If the Error message is related to the verification code,
                  please make sure to click on ‘Verify’ once you have inputted
                  the code, until it becomes ‘Verified’{" "}
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  -If the Error message is related to ‘Email already exists’ it
                  means you have already made an account. In this case, you will
                  need to Sign In, instead of creating a new account{" "}
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  -The Hayya Media Portal works best at Google Chrome &
                  Microsoft Edge. If your corporate network has security
                  firewall that prevents access, kindly connect to a different
                  network
                </li>
              </ul>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">3</h1>
              <div className={`${styles.question}   fw-bold`}>
                I made a mistake on my application and want to change the
                information, what do I do?
              </div>
              <ul>
                <li className={`${styles.answer}   mt-2`}>
                  -There is no other way to correct this information, unless
                  contacted by the Hayya Media Portal. This is a security
                  measure as information cannot be changed while it is being
                  processed by local authorities{" "}
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  -Applications are vetted & reviewed as they go through the
                  required approvals. When an amendment is required, applicants
                  would receive an email from the Hayya Media Portal requesting
                  for corrections to be made to the application, in which case
                  the applicant can have access to their application once again
                </li>
              </ul>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">4</h1>
              <div className={`${styles.question}   fw-bold`}>
                I still haven’t received any approval or rejection on my status,
                why?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                If applicants do not receive approval or rejection emails, this
                means the application is still being processed. There is nothing
                to be done at this stage except to wait for the outcome once the
                application completes the required steps. You will be notified
                of the outcome once this is complete.
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">5</h1>
              <div className={`${styles.question}   fw-bold`}>
                My personal photo and passport got rejected, why?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                Photos & passport copies must be compliant with standard visa
                requirements worldwide.
              </div>
              <div className="mt-4">
                <img src="/assets/images/passport.jpg" className="w-100" />
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">6</h1>
              <div className={`${styles.question}   fw-bold`}>
                I was registered as a bulk admin to upload my colleague’s data,
                how can I update their profiles when they are asked for
                amendments?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                Bulk admin users cannot edit information on behalf of their
                colleagues, because each Hayya Media Portal applicant receives a
                message on their email listed under their account. For staff to
                access their profiles if uploaded using the admin, they will
                need to register first then make the required amendments.
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">7</h1>
              <div className={`${styles.question}   fw-bold`}>
                I accidentally applied for the wrong category, what can I do?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                Please email{" "}
                <a className="text-red" href="mailto:media@hayya.qa">
                  {t("support-email")}
                </a>{" "}
                or your organisation’s focal point (for MRLs) and we will delete
                your application and request for a resubmission. In this case,
                you will not need to register an email, you will simply{" "}
                <span>Sign In </span>and continue the application process as
                required.
              </div>
            </div>
          </div>
        </div>
        <div className={`${styles.faq} `} id="faqHayya">
          <h1
            className={`${styles.sectionstitle} text-burgundy   fw-bold `}
          >
            FAQ - Hayya
          </h1>
          <div className="ps-md-5 mt-5">
            <div>
              <h1 className="fw-bold text-burgundy">1</h1>
              <div className={`${styles.question}   fw-bold`}>
                Can I apply for the Hayya Entry Permit?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                There is no separate application for Hayya. An application
                through the Hayya Media Portal generates a Hayya Entry Permit
                and Host Country Accreditation / Upgrade Pass in addition to the
                standardized Film Permit, altogether as a result of 1
                application.{" "}
              </div>
              <div className={`${styles.answer}   mt-3`}>
                Media applicants <span>must not</span> apply for a Hayya Account
                separately. Any separate accounts created via Hayya will result
                in duplications as one applicant cannot have two Hayya IDs. Such
                cases may result in delays with obtaining the required approvals
                in a timely manner from the Hayya Media Portal.
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">2</h1>
              <div className={`${styles.question}   fw-bold`}>
                My Hayya ID says ‘Organiser’, is this correct?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                Yes. Hayya IDs fall into one of two categories – 'Fan' or
                'Organiser'. Media & Broadcasters fall under the Organiser
                category.
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">3</h1>
              <div className={`${styles.question}   fw-bold`}>
                Can I print my Hayya Card?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                Physical cards are only offered to fans. Media as a result
                cannot print their Digital Hayya Cards; this will not be
                required, anyhow, since Media only need to present their
                Accreditation to access respective sites.
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">4</h1>
              <div className={`${styles.question}   fw-bold`}>
                I cannot access the Hayya App, it says my account cannot be
                found even after I received my approved Hayya Entry Permit via
                the Hayya Media Portal.
              </div>
              <div className={`${styles.answer}   mt-2`}>
                While the Hayya Media Portal links media applications with the
                Hayya, the Hayya Media Portal application does not automatically
                generate an account on the Hayya App.
                <span className="text-decoration-none text-burgundy">
                  {" "}
                  Applicants will only be able to access their Hayya accounts
                  once they register with the same email used on the Hayya Media
                  Portal, on the Hayya Mobile App. This step is necessary in
                  order to have access to your Digital Hayya.
                </span>
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">5</h1>
              <div className={`${styles.question}   fw-bold`}>
                How can I edit my profile on the Hayya ID if I receive a
                notification of rejection due to an application error?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                Media applicants cannot update the information directly on their
                Hayya Mobile App. They can only update / amend their profile via
                the Hayya Media Portal. The Hayya Media Portal is linked to the
                Hayya ID for each applicant, the Hayya Media Portal team will be
                able to see the errors applicants receive. If an error occurs,
                the applicant would receive an email from the Hayya Media Portal
                requesting for the applicant to Sign back on to the portal and
                amend information / attachments as necessary.
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">6</h1>
              <div className={`${styles.question}   fw-bold`}>
                I got a notification that my Hayya ID was cancelled and another
                one was approved shortly after, why did this happen?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                Media applicants cannot have two Hayya IDs under their name.
                Given that the Hayya Media Portal generates an Organiser Hayya
                for media as part of their Hayya Media Portal process, any Hayya
                IDs applied for separately / previously, will be cancelled so
                the new one can be considered.
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">7</h1>
              <div className={`${styles.question}   fw-bold`}>
                I received the below automatic email from Hayya once my
                application was approved. Is this applicable to media?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                Media applicants cannot have two Hayya IDs under their name.
                Given that the Hayya Media Portal generates an Organiser Hayya
                for media as part of their Hayya Media Portal process, any Hayya
                IDs applied for separately / previously, will be cancelled so
                the new one can be considered.
              </div>
              <div className="my-4">
                <img
                  src="/assets/images/automatic-email.jpg"
                  className="w-100"
                />
              </div>
              <div className={`${styles.answer}   mt-3`}>
                The above Hayya communication is a standard email shared with
                all applicants (Fans & Organisers), this{" "}
                <span className="text-decoration-none text-burgundy">
                  does not apply to media
                </span>
                , however. Please abide only by the regulations & guidelines
                communicated via the Hayya Media Portal.
              </div>
            </div>
          </div>
        </div>
        <div id="faqAccomodation">
          <h1
            className={`${styles.sectionstitle} text-burgundy   fw-bold `}
          >
            FAQ - Accomodation
          </h1>
          <div className="ps-md-5 mt-5">
            <div>
              <h1 className="fw-bold text-burgundy">1</h1>
              <div className={`${styles.question}   fw-bold`}>
                How can I book my accommodation?
              </div>
              <ul>
                <li className={`${styles.answer}   mt-2`}>
                  - Host Country Media applying on the portal do not need proof
                  of accommodation upon registering on the Hayya Media Portal.
                  However, if media representatives are interested to apply for
                  accommodation, please contact:
                  <a
                    href="mailto:media-enquiries@book.qatar2022.qa"
                    className="text-red"
                  >
                    media-enquiries@book.qatar2022.qa
                  </a>{" "}
                  .
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  {" "}
                  - Only media who receive approval on their applications can
                  request Host Country accommodation (i.e. once their Entry
                  Permit is sent).{" "}
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  - Please note that FIFA Accommodation is booked separately,
                  it’s best to speak with your Q22 or FIFA focal points for
                  further details.
                </li>
              </ul>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">2</h1>
              <div className={`${styles.question}   fw-bold`}>
                Can I add people (friends / family) to my Hayya as an
                'Organiser'?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                No; addition of friends & family applies to Fans only.
              </div>
            </div>
          </div>
        </div>
        <div id="faqFimlingPermits">
          <h1
            className={`${styles.sectionstitle} text-burgundy   fw-bold `}
          >
            FAQ - Filming Permits
          </h1>
          <div className="ps-md-5 mt-5">
            <div>
              <h1 className="fw-bold text-burgundy">1</h1>
              <div className={`${styles.question}   fw-bold`}>
                How do I apply for a Film Permit?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                The application process is unified, therefore, in applying for
                Host Country Media Accreditation the same information will be
                used to generate a standardised Film Permit that will allow the
                recipient of the Host Country Media Accreditation / Host Country
                Media Upgrade Pass to film in various locations around the
                country by presenting their Host Country Media Accreditation /
                Host Country Media Upgrade Pass. A list of prohibited locations
                is provided on the Hayya Media Portal where additional approvals
                are required to film.
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">2</h1>
              <div className={`${styles.question}   fw-bold`}>
                How do I apply for a Film Permit?
              </div>
              <ul>
                <li className={`${styles.answer}   mt-2`}>
                  - Filming Permits enable Media to take photos & videos around
                  Qatar at touristic locations / open spaces{" "}
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  - Filming Permits do not permit the holder to film / take
                  photos in restricted areas. These areas are marked with clear
                  signs showing ‘no film’ / ‘no photos’, or where security
                  guards of the location provide the same. These locations are
                  also stated in the Application Terms & Conditions on the Qatar
                  Media Portal
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  - Media do not need to apply for Filming Permits
                  independently. Film Permits will be generated as part of the
                  Host Country Accreditation / Entry Permit application
                  submission, made on the Hayya Media Portal
                </li>
              </ul>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">3</h1>
              <div className={`${styles.question}   fw-bold`}>
                What are the Film Permit Terms & Conditions that I need to agree
                to when submitting my application on the Hayya Media Portal?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                This permit allows filming / photography across the State of
                Qatar, except for the following locations:
              </div>
              <ul>
                <li className={`${styles.answer}   mt-2`}>
                  - Barracks & Military Bases{" "}
                </li>
                <li className={`${styles.answer}  `}>
                  - Security or police buildings
                </li>
                <li className={`${styles.answer}  `}>
                  - Chancelleries
                </li>
                <li className={`${styles.answer}  `}>
                  - All borders (land, sea and aerial)
                </li>
                <li className={`${styles.answer}  `}>
                  - Residential properties, private businesses and industrial
                  zones
                </li>
              </ul>
              <div className={`${styles.answer}   mt-3`}>
                {" "}
                Filming is prohibited inside the following:
              </div>
              <ul>
                <li className={`${styles.answer}   mt-3`}>
                  - Governmental, educational, health institutions and places of
                  worship
                </li>
                <li className={`${styles.answer}   `}>
                  - Restricted areas where filming requires prior permission
                </li>
                <li className={`${styles.answer}   `}>
                  - Any site with signage or security advising of no
                  photography/videography
                </li>
              </ul>
              <div className={`${styles.answer}   mt-3`}>
                By submitting this form, you/ your organisation agree to the
                following terms:
              </div>
              <ul>
                <li className={`${styles.answer}   `}>
                  - Only capture film/ photography at permitted locations
                </li>
                <li className={`${styles.answer}   `}>
                  - Not to capture film/ photography at the excluded locations
                  listed above
                </li>
                <li className={`${styles.answer}   `}>
                  - Respect the privacy of individuals & to not intrude on their
                  personal lives or film them or their properties without their
                  express prior approval{" "}
                </li>
                <li className={`${styles.answer}   `}>
                  - To comply with Qatari laws{" "}
                </li>
              </ul>
              <div
                className={`${styles.answer}   mt-3 text-decoration-underline`}
              >
                The permit also does not allow filming with drones.
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">4</h1>
              <div className={`${styles.question}   fw-bold`}>
                Which locations are included in the Film Permit?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                The application process is unified, therefore, in applying for
                Host Country Media Accreditation the same information will be
                used to generate a standardised Film Permit that will allow the
                recipient of the Host Country Media Accreditation / Host Country
                Media Upgrade Pass to film in various locations around the
                country by presenting their Host Country Media Accreditation /
                Host Country Media Upgrade Pass. A list of prohibited locations
                is provided on the Hayya Media Portal where additional approvals
                are required to film.
              </div>
              <div className="mt-4">
                <table className="Ftable border-orange p-4">
                  <thead>
                    <tr>
                      <th>
                        <div className="d-flex">
                          <img src="/assets/svg/area.svg" />
                          <p className="d-inline-block m-0">
                            {t("filming-title1")}
                          </p>
                        </div>
                      </th>
                      <th>
                        <div className="d-flex">
                          <img src="/assets/svg/location.svg" />
                          <p className="d-inline-block m-0">
                            {" "}
                            {t("filming-title1-1")}
                          </p>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{t("filming-table1")}</td>
                      <td>{t("filming-table1-1")}</td>
                    </tr>
                    <tr>
                      <td>{t("filming-table2")}</td>
                      <td>{t("filming-table2-2")}</td>
                    </tr>
                    <tr>
                      <td>{t("filming-table3")}</td>
                      <td>{t("filming-table3-3")}</td>
                    </tr>
                    <tr>
                      <td>{t("filming-table4")}</td>
                      <td>{t("filming-table4-4")}</td>
                    </tr>
                    <tr>
                      <td>{t("filming-table5")}</td>
                      <td>{t("filming-table5-5")}</td>
                    </tr>
                    <tr>
                      <td>{t("filming-table6")}</td>
                      <td>{t("filming-table6-6")}</td>
                    </tr>
                    <tr>
                      <td>{t("filming-table7")}</td>
                      <td>{t("filming-table7-7")}</td>
                    </tr>
                    <tr>
                      <td>{t("filming-table9")}</td>
                      <td>{t("filming-table9-9")}</td>
                    </tr>
                    <tr>
                      <td>{t("filming-table10")}</td>
                      <td>{t("filming-table10-10")}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div id="faqEquipmentClearance">
          <h1
            className={`${styles.sectionstitle} text-grey   fw-bold `}
          >
            FAQ - Equipment Clearance
          </h1>
          <div className="ps-md-5 mt-5">
            <div>
              <h1 className="fw-bold text-grey">1</h1>
              <div className={`${styles.question}   fw-bold`}>
                How can I apply for Hand Carry Filming Equipment Clearance?
              </div>
              <ul>
                <li className={`${styles.answer}   mt-2`}>
                  - Media that intend to bring equipment through Hand Carry must
                  complete the Hand Carry form on the Hayya Media Portal 1 to 2
                  weeks ahead of arrival{" "}
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  - Once approved on the Hayya Media Portal, applicant must
                  ‘Sign In’ on{" "}
                  <a
                    href="https://media.hayya.qa"
                    className="text-red"
                    target="_blank"
                  >
                    https://media.hayya.qa
                  </a>{" "}
                  and fill the Equipment Clearance Form found under the Media
                  Services menu tab, by selecting Equipment Clearance and
                  proceeding to the “Declare Now” button{" "}
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  - Declaring this equipment, particularly any cameras or
                  equipment with frequency, is important to ensure applicants
                  have necessary permits to clear the Customs check at the
                  airport or land border. The Equipment Clearance Form is simple
                  & takes a few minutes to complete. All the information
                  provided must be accurate ahead of submission. In the event of
                  rejection, applicant will receive comments on the missing or
                  incorrect information, you will then need to submit a new form
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  {" "}
                  - In case an applicant is planning to enter & exit Qatar on
                  multiple trips, and expects to bring a different set of
                  equipment, applicant must apply for a second permit using the
                  same system (detailed above){" "}
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  - In case the applicant brings additional equipment to those
                  already declared through the Hayya Media Portal, they must
                  complete a new application with the additional equipment and
                  present to the Customs Team upon arrival.{" "}
                  <span className="fw-medium text-decoration-none">
                    Applicants must apply at least one week ahead of the
                    Departure date
                  </span>
                </li>
                <li
                  className={`${styles.answer}   mt-3 text-burgundy`}
                >
                  {" "}
                  - Personal items such as laptops, power banks and mobile
                  phones do not need to be declared. Only filming & photography
                  equipment (Cameras, camera accessories, wireless equipment
                  etc.)
                </li>
              </ul>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">2</h1>
              <div className={`${styles.question}   fw-bold`}>
                I was late in submitting & only have one/two days before I
                travel, what do I do?
              </div>
              <div className={`${styles.answer}   mt-2`}>
                While this is not preferred, applicant is still advised to apply
                for Equipment Clearance at their earliest, and we will aim to
                facilitate with the authorities.
              </div>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">3</h1>
              <div className={`${styles.question}   fw-bold`}>
                What are the Cargo procedures of the State of Qatar?
              </div>

              <ul>
                <li className={`${styles.answer}   mt-2`}>
                  - Host Country Media that intend to ship equipment / material
                  through Air or Sea Freight must follow standard Customs
                  Procedures detailed on{" "}
                  <a
                    href="https://ecustoms.gov.qa/qccsw/jsf/common/custExternalHome_userGuide.jsf"
                    className="text-red"
                    target="_blank"
                  >
                    {" "}
                    the Customs Clearance Policy
                  </a>
                  . Shipping requires the identification of a recognised
                  shipping company{" "}
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  - FIFA-Accredited media must align with their FIFA / Q22 focal
                  points to explain their shipment policy
                </li>
              </ul>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">4</h1>
              <div className={`${styles.question}   fw-bold`}>
                What about drone imports?
              </div>
              <ul>
                <li className={`${styles.answer}   mt-2`}>
                  {" "}
                  - Drone importation is limited. If you are interested in
                  requesting to import drones, please email{" "}
                  <a href="mailto:HC_Drones@sc.qa" className="text-red">
                    HC_Drones@sc.qa
                  </a>{" "}
                  in the event you are Host Country Accredited Media
                </li>
                <li className={`${styles.answer}   mt-3`}>
                  {" "}
                  - FIFA Accredited Media are advised to approach their FIFA /
                  Q22 focal points
                </li>
              </ul>
            </div>
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">5</h1>
              <div className={`${styles.question}   fw-bold`}>
                What happens if I don’t declare Hand Carry Equipment ahead of
                arrival to Doha?
              </div>

              <div className={`${styles.answer}   mt-2`}>
                In the event hand-carry equipment is not declared through the
                submission of the Hand Carry form on the Hayya Media Portal,
                equipment may be confiscated at the airport. If equipment is not
                cleared during the applicant’s stay, it can be collected on the
                way out of the country using the slip received by the Customs
                Office upon entry. Kindly apply for clearance to avoid such
                instances from occurring.
              </div>
            </div>
          </div>
        </div>
        <div id="faqCovid">
          <h1
            className={`${styles.sectionstitle} text-burgundy   fw-bold `}

          >
            FAQ - COVID Regulations
          </h1>
          <div className="ps-md-5 mt-5 ">
            <div className="mt-4 pt-2">
              <h1 className="fw-bold text-burgundy">1</h1>
              <div className={`${styles.question}   fw-bold`}>
                Do I need to be vaccinated in order to enter the State of Qatar?
              </div>
              <div className={`${styles.answer}   mt-2`}>No.</div>
            </div>
            <div className="mt-4">
              <h1 className="fw-bold text-burgundy">2</h1>
              <div className={`${styles.question}   fw-bold`}>
                Do I need to undertake a 24 rapid antigen OR 48 PCR ahead of
                arriving in the State of Qatar?
              </div>
              <div className={`${styles.answer}   mt-2`}>No.</div>
            </div>
            <div className="mt-4">
              <div>
                <h1 className="fw-bold text-burgundy">3</h1>
                <div className={`${styles.question}   fw-bold`}>
                  Is EHTERAZ Pre-Registration required?
                </div>
                <div className={`${styles.answer}   mt-2`}>
                  No. Ehteraz app is only required when entering healthcare
                  facilities in Qatar.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="faqQMPHCMS">
          <h1 className={`${styles.sectionstitle} text-burgundy   fw-bold `} >FAQ - QMP Host Country Media Services</h1>
          <div className="ps-md-5 mt-5">
            <div className={`${styles.answer}`}><a href="/assets/pdf/FAQ-QMP-Host-country-media-servcices.pdf" target="_blank" className="text-burgundy   ">Click to download HMP Host Country Media Services FAQs</a></div>

          </div>
        </div> */}
      </div>
      <div className="my-5">
        <WeatherWidget /></div>
      <div className={`${styles.faqs} container faqs position-relative`}>
        <div
          className={` ${styles.hidden} ${scrollY > 620 ? styles.visible : ""
            } ${scrollY > 12300 ? styles.hidden1 : ""}`}
        >
          <a href="#shortcuts" className="text-center">
            <img src="/assets/svg/goup.svg" />
            <div className="ff-bold2022 text-burgundy fw-bold">Go Up</div>
          </a>
        </div>
      </div>
    </>
  );
}

FAQs.getLayout = function getLayout(page) {
  return (
    <Layout>
      <Nav />
      {page}

      <Footer />
    </Layout>
  );
};

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
